module.exports = __webpack_public_path__ + "img/pentab_mouse.77b05941.jpg";